import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["bar"];

  connect() {
    this.element.addEventListener("progress:nextStep", this.nextStep.bind(this));
    this.element.addEventListener("progress:backStep", this.backStep.bind(this));
  }

  async nextStep() {
    const currentStep = parseInt(this.element.dataset.currentStep, 10);
    const oldBar = this.barTargets[currentStep - 1];
    const newBar = this.barTargets[currentStep];

    if (oldBar) {
      await this.fillBar(oldBar, 100);
    }

    if (newBar) {
      await this.fillBar(newBar, 10);
      this.element.dataset.currentStep = currentStep + 1;
    }
  }

  async backStep() {
    const currentStep = parseInt(this.element.dataset.currentStep, 10);
    const oldBar = this.barTargets[currentStep - 1];
    const newBar = this.barTargets[currentStep - 2];

    if (oldBar) {
      await this.fillBar(oldBar, 0);
    }

    if (newBar) {
      await this.fillBar(newBar, 10);
    }
    
    this.element.dataset.currentStep = currentStep - 1;
  }

  fillBar(barElement, value) {
    return new Promise((resolve) => {
      if (!barElement) {
        return resolve();
      }

      barElement.setAttribute("aria-valuenow", value);

      const fillElement = barElement.children[0];
      fillElement.style.width = `${value}%`;

      const afterTransition = () => {
        resolve();
      };

      fillElement.addEventListener("transitionend", afterTransition);
    });
  }
}
